import { Outlet } from 'react-router-dom'

/**
 * SiteUrlSync Component
 *
 * Wrapper component for site-level routes where siteId is part of the URL path.
 * With path-based routing (/s/:siteId/*), the siteId is automatically available
 * via useParams() and synced to the store by NavigationGuard.
 *
 * This component now serves as a semantic wrapper to indicate site-level routes
 * and can be extended in the future for site-specific logic if needed.
 *
 * Route structure:
 * - /s/:siteId/* - Site-level routes (clients, schedule, payments, etc.)
 * - /c/* - Corporate-level routes (user-access, control-center, etc.)
 *
 * @example
 * // In router.jsx
 * {
 *   path: 's/:siteId',
 *   element: <SiteUrlSync />,
 *   children: [
 *     CLIENTS_ROUTES,
 *     SETTINGS_ROUTES,
 *     // ... all site-level routes
 *   ]
 * }
 */
export const SiteUrlSync: React.FC = () => {
  return <Outlet />
}

export default SiteUrlSync
